<main class="list-component mb-[20px]">
	<div class="rounded-lg shadow bg-white flex">
		<div
			class="check-area rounded-l-lg rounded-r-lg min-w-[30px] flex justify-center items-center"
			(click)="handleSelect()"
			[class.selected]="data.selected"
			[class.disabled]="disabledControl"
		>
			<lbca-icon name="lucide:check" class="svg-icon-check block"></lbca-icon>
		</div>
		<div class="w-full p-4">
			<div class="ff-row-form overflow-x-hidden pt-[20px]">
				<div class="ff-box-field ff-field-size-3">
					<lbca-select
						[label]="'Título da Tarefa'"
						[require]="true"
						[error]="errors['taskAction_Phalange'] && hasError ? errors['taskAction_Phalange'] : []"
						[value]="data.taskAction_Phalange"
						[options]="taskOptions"
						(changeValue)="handleTitle($event)"
						[disabled]="disabledControl"
					></lbca-select>
				</div>
			</div>
			<div class="divider"></div>
			<div class="ff-row-form overflow-x-hidden pt-[20px]">
				<ng-container *ngTryFor="let field of template?.fields">
					<ng-container
						*ngTemplateOutlet="fieldMultiplex; context: { dataField: field }"
					></ng-container>
				</ng-container>
			</div>
		</div>
	</div>
</main>
<ng-template let-field="dataField" #fieldMultiplex>
	<div [ngClass]="'ff-field-size-' + field.size" [class.ff-box-field]="!(field.size === 0)">
		@if (field.type === 'TEXTAREA') {
			<lbca-textarea
				[label]="field.label"
				[error]="errors[field.entityKey] && hasError ? errors[field.entityKey] : []"
				[disabled]="
					disabledControl ||
					field.disabled ||
					(field.childrenDependency &&
						dynamicFormService.formControlStructure.fieldControl[field.entityKey].disabled)
				"
				[require]="field.required"
				(changeValue)="handleChange($event, field.entityKey)"
				[value]="data ? data['fields'][field.entityKey] : ''"
				[helperText]="field.helperText"
			></lbca-textarea>
		}
		@if (field.type === 'SELECT_ONE') {
			<lbca-select
				[label]="field.label"
				[error]="errors[field.entityKey] && hasError ? errors[field.entityKey] : []"
				[disabled]="
					disabledControl ||
					field.disabled ||
					(field.childrenDependency &&
						dynamicFormService.formControlStructure.fieldControl[field.entityKey].disabled)
				"
				[require]="field.required"
				[value]="data ? data['fields'][field.entityKey] : ''"
				[options]="data ? fieldOptions[field.entityKey] : ''"
				(changeValue)="handleChange($event, field.entityKey)"
			></lbca-select>
		}
		@if (field.type === 'CALENDAR') {
			<lbca-date-picker
				[label]="field.label"
				[error]="errors[field.entityKey] && hasError ? errors[field.entityKey] : []"
				[disabled]="
					disabledControl ||
					field.disabled ||
					(field.childrenDependency &&
						dynamicFormService.formControlStructure.fieldControl[field.entityKey].disabled)
				"
				[require]="field.required"
				(changeValue)="handleChange($event, field.entityKey)"
				[value]="data ? data['fields'][field.entityKey] : ''"
				[helperText]="field.helperText"
				[rules]="field.rules || []"
				[min]="data ? data.min : null"
				(setError)="handleError($event)"
				[max]="selectedTask ? selectedTask[field.entityKey] : null"
				[disabledDateRules]="field.disabledDateRules || []"
			></lbca-date-picker>
		}

		<!-- <ng-container class="mt-[5px] pt-[5px]" *ngIf="dynamicFormService.formControlStructure.fieldControl[field.entityKey].visible && dynamicFormService.formControlStructure.fieldControl[field.entityKey].locked && !dynamicFormService.formControlStructure.fieldControl[field.entityKey].unlocked">
    <div class="dyc-dependency-module">

      <div class="ff-row-form mb-[15px]">
        <p class="text-font text-xs">{{ field.label }}</p>
      </div>

      <div class="dyc-msg-container">
        <div class="flex flex-col">
          <div class="dyc-text-msg">{{ dynamicFormService.formControlStructure.fieldControl[field.entityKey].msg }}</div>
        </div>
        <div class="emojis-shackle icon-box ml-[16px]"></div>
      </div>
    </div>
  </ng-container> -->
	</div>
</ng-template>
